<script setup lang="ts">
import type { AwardItemProps } from '@/types/appTypes'

const props = withDefaults(defineProps<AwardItemProps>(), {
  dispCount: false,
  result: false,
  rank: 0,
  preview: false,
})
const app = useNuxtApp()
</script>

<template>
  <div
    class="c-charaItem"
    v-bind:class="{
      'is-topRank': result && rank >= 1 && rank <= 3,
      'is-rank1': result && rank === 1,
    }"
  >
    <div
      v-if="result && rank >= 1 && rank <= 3"
      class="c-charaItem_rank"
    >
      <span>{{ rank }}</span>位
    </div>
    <nuxt-link
      class="c-charaItem_image"
      v-bind:to="item.toDetail"
    >
      <CommonImage
        v-bind:src="item.image.url"
        v-bind:alt="item.title"
        object-fit="contain"
        error-src="/images/noimage.svg"
        is-hover-effect
      />
    </nuxt-link>
    <div class="c-charaItem_body">
      <div class="c-charaItem_body_title">
        {{ item.title }}
      </div>
      <div
        v-if="item.museum"
        class="c-charaItem_body_museum"
      >
        <nuxt-link
          v-bind:to="item.toMuseum"
        >
          {{ item.museum }}
        </nuxt-link>
      </div>
      <div
        v-if="dispCount"
        class="c-charaItem_body_count"
      >
        {{ app.$anyToComma(item.articleCommentCount) }} 票
      </div>
      <div
        v-if="dispCount"
        class="c-charaItem_body_link"
      >
        <ArrowLink
          v-bind:to="item.toComment"
          label="応援メッセージ"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use "@/assets/css/foundation/mixin/responsive";

.c-charaItem {
  display: flex;
  flex-direction: column;
  width: 25%;
  padding: 15px 8px;

  @include responsive.mq_down(sp) {
    display: block;
    width: 100%;
  }

  &_image {
    height: 168px;

    @include responsive.mq_down(sp) {
      display: block;
      max-width: 200px;
      margin: 0 auto;
    }

    &:hover {
      opacity: 0.7;
    }
  }

  &_body {
    flex-grow: 1;
    margin-top: 10px;
    padding: 10px;
    background-color: var(--color_background_whiteblue);

    &_title {
      font-size: 16px;
      font-weight: bold;
      text-align: center;
    }

    &_museum {
      font-size: 14px;
      font-weight: bold;
      text-align: center;
    }

    &_count {
      text-align: center;
    }

    &_link {
      display: flex;
      justify-content: center;
    }
  }

  &.is-topRank {
    flex-direction: row;
    align-items: center;
    width: 100%;
    height: 239px;
    margin-bottom: 15px;
    border: 2px solid #0093b2;
    border-radius: 12px;

    @include responsive.mq_down(sp) {
      height: auto;
    }
  }

  &.is-topRank & {
    &_rank {
      flex-shrink: 0;
      width: 120px;
      color: #0093b2;
      font-size: 40px;
      font-weight: bold;
      text-align: center;
      white-space: nowrap;

      @include responsive.mq_down(sp) {
        font-size: 20px;
      }

      span {
        font-size: 80px;

        @include responsive.mq_down(sp) {
          font-size: 40px;
        }
      }
    }

    &_image {
      width: 200px;
      height: 200px;
    }

    &_body {
      margin-top: 0;
      padding: 10px;
      background-color: transparent;

      &_title {
        font-size: 25px;
      }

      &_museum {
        font-size: 20px;
        font-weight: bold;
      }

      &_count {
        font-size: 25px;
        font-weight: bold;
      }

      &_link {
        font-size: 18px;
        text-align: center;
      }

      @include responsive.mq_down(sp) {
        &_title {
          font-size: 20px;
        }

        &_museum {
          font-size: 18px;
        }

        &_count {
          font-size: 20px;
        }

        &_link {
          font-size: 16px;
        }
      }
    }
  }

  &.is-rank1 {
    border: 5px solid #0093b2;
  }

  &.is-rank1 & {
    &_rank {
      font-size: 50px;
      font-weight: bold;

      @include responsive.mq_down(sp) {
        font-size: 30px;
      }

      span {
        font-size: 100px;

        @include responsive.mq_down(sp) {
          font-size: 60px;
        }
      }
    }

    &_body {
      &_title {
        font-size: 30px;
      }

      &_museum {
        font-size: 25px;
        font-weight: bold;
      }

      &_count {
        font-size: 25px;
        font-weight: bold;
      }

      &_link {
        font-size: 18px;
        text-align: center;
      }

      @include responsive.mq_down(sp) {
        &_title {
          font-size: 25px;
        }

        &_museum {
          font-size: 20px;
        }

        &_count {
          font-size: 20px;
        }

        &_link {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
